// this hook is meant to query the contentful fields.
import * as contentful from "contentful";

const useContentful = () => {
  const client = contentful.createClient({
    space: process.env.REACT_APP_SPACE_ID,
    accessToken: process.env.REACT_APP_CONTENT_DELIVERY_TOKEN,
    host: process.env.REACT_APP_HOST_DELIVERY,
  });

  /*This method fetch "static" field from contentful */
  const getCmsResponse = async (contentType) => {
    try {
      let queryParameters = {
        content_type: contentType,
        select: "fields,sys.createdAt,sys.updatedAt",
        include: 10,
      };
  
      if (contentType === 'projects' || contentType === 'training') {
        queryParameters.order = 'fields.sortOrder'; 
      }
  
      const entries = await client.getEntries(queryParameters);

      const sanitizedEntries = entries.items.map((item) => {
        return { ...item.fields, id: item.sys.id, dateCreated: item.sys.createdAt, dateUpdated: item.sys.updatedAt};
      });

      return sanitizedEntries;
    } catch (error) {
      console.error(`error fetching ${contentType} , ${error}`);
    }
  };

  return { getCmsResponse };
};

export default useContentful;
